var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE4DataCenter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.07 23.89A8.11 8.11 0 0164 32h-3v-5H28.07a6.158 6.158 0 01-.13-1.3 6.5 6.5 0 016.53-6.3v-1.29c0-3.57 4.4-7.59 9.75-5.57l.24.15A9.44 9.44 0 0163 15.1v.52c.31 0 .62-.06.94-.06a8.26 8.26 0 018.13 8.33zM7 31h50v36H7V31zm4 16h42V35H11v12zm0 16h42V51H11v12zm17-4h19v-4H28v4zm0-16h19v-4H28v4zM17 59h4v-4h-4v4zm0-16h4v-4h-4v4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E4_Data_center.b8c5e995.svg";
export { SvgE4DataCenter as ReactComponent };